import { BiGroup, BiLineChartDown } from "react-icons/bi";
import { AiOutlineUsergroupAdd, AiOutlineAlert } from "react-icons/ai";
import {
  MdDashboard,
  MdOutlineDocumentScanner,
  MdOutlineFeedback,
  MdHistory,
  MdTimeline,
} from "react-icons/md";
import { USER_ROLE } from "../constant";
import {
  RiCustomerService2Fill,
  RiCalendar2Fill,
  RiArticleLine,
  RiMedicineBottleLine,
} from "react-icons/ri";
import { PERMISSION_KEYS } from "store/constants";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import { TbReport } from "react-icons/tb";
import { FaHome } from "react-icons/fa";
import { FiAlertTriangle, FiActivity } from "react-icons/fi";

export const SpAdminNavigation = [
  {
    name: "Dashboard",
    icon: MdDashboard,
    current: false,
    to: "/",
    role: [USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager],
    // permissionName: PERMISSION_KEYS.DASHBOARD,
  },
  {
    name: "Participants",
    icon: AiOutlineUsergroupAdd,
    current: false,
    to: "/participant-list",
    children: [{ name: "Participant List", href: "/participant-list" }],
    role: [USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager],
    permissionName: PERMISSION_KEYS.PARTICIPANT,
  },
  {
    name: "HRM",
    icon: BiGroup,
    current: false,
    to: "/hrm",
    role: [USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager],
    permissionName: PERMISSION_KEYS.HRM,
  },
  {
    name: "Support Coordination",
    icon: RiCustomerService2Fill,
    current: "/cos/",
    to: "/cos/dashboard",
    role: [USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager],
    permissionName: PERMISSION_KEYS.COS,
  },
  {
    name: "Allied Health",
    icon: RiMedicineBottleLine,
    current: "/ah/",
    to: "/ah/dashboard",
    role: [USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager],
    permissionName: PERMISSION_KEYS.ALLIED_HEALTH,
  },
  {
    name: "Rostering",
    icon: RiCalendar2Fill,
    current: false,
    to: "/rostering/dashboard",
    role: [USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager],
    permissionName: PERMISSION_KEYS.ROSTERING,
  },
  {
    name: "Home Management",
    icon: FaHome,
    current: false,
    to: "/sil-accommodation",
    role: [USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager],
    permissionName: PERMISSION_KEYS.SIL,
  },
  {
    name: "Incident Management",
    icon: FiAlertTriangle,
    current: false,
    to: "/incident-management",
    role: [USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager],
    permissionName: PERMISSION_KEYS.INCIDENT_MANAGEMENT,
  },
  {
    name: "Care Watch",
    icon: FiActivity,
    current: false,
    to: "/care-watch",
    role: [USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager],
  },
  {
    name: "Invoicing",
    icon: RiArticleLine,
    current: false,
    to: "/rostering/invoicing/dashboard",
    role: [USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager],
    permissionName: PERMISSION_KEYS.ROSTER_INVOICE,
  },
  {
    name: "Reporting",
    icon: TbReport,
    current: false,
    to: "/reporting",
    role: [USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager],
    permissionName: PERMISSION_KEYS.REPORTING,
  },
  {
    name: "Audit Log",
    icon: MdHistory,
    current: false,
    to: "/audit-log",
    role: [USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager],
    permissionName: "audit_log",
  },
  {
    name: "User Sessions",
    icon: MdTimeline,
    current: false,
    to: "/user-sessions",
    role: [USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager],
    permissionName: "user_sessions",
  },
  {
    name: "Forms Management CRM",
    icon: BiLineChartDown,
    current: false,
    to: "/forms-list",
    role: [USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager],
    permissionName: PERMISSION_KEYS.CRM_FORM,
  },
  {
    name: "Forms Management HRM",
    icon: BiLineChartDown,
    current: false,
    to: "/forms-list-hrm",
    role: [USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager],
    permissionName: PERMISSION_KEYS.HRM_FORM,
  },
  {
    name: "Forms Home MGT",
    icon: BiLineChartDown,
    current: false,
    to: "/forms-accommodation",
    role: [USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager],
    permissionName: PERMISSION_KEYS.SIL,
  },
  {
    name: "Policies",
    icon: MdOutlineDocumentScanner,
    current: false,
    to: "/policies",
    role: [USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager],
    permissionName: PERMISSION_KEYS.POLICy,
  },
  {
    name: "Complaints",
    icon: AiOutlineAlert,
    current: false,
    to: "/complaints",
    role: [USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager],
    permissionName: PERMISSION_KEYS.COMPLAINT,
  },
  {
    name: "Feedback",
    icon: MdOutlineFeedback,
    current: false,
    to: "/feedbacks",
    role: [USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager],
    permissionName: PERMISSION_KEYS.FEEDBACK,
  },
  {
    name: "Ask a Question",
    icon: AiOutlineQuestionCircle,
    current: false,
    to: "/ask-a-question",
    role: [USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager],
    permissionName: PERMISSION_KEYS.ASK_QUESTION,
  },
  // {
  //   name: "Notification Setting",
  //   icon: MdEditNotifications,
  //   current: false,
  //   to: "/notification-setting",
  //   role: [USER_ROLE.Sp_Admin],
  // },
];
